import React from 'react';

import styles from './talent.module.scss';

export const TalentJobs = ({ content }) => (
  <div className={styles.talentJobs}>
    <div className={styles.singleItem} dangerouslySetInnerHTML={{ __html: content }} />
  </div>
);
